import { Card } from "antd";
import styled from "styled-components";

export const StyledCard = styled(Card)<{ $status: boolean }>`
    position: relative;
    overflow: hidden;

    .ant-card-body {
        padding: 16px;
        padding-right: 20px;
        position: relative;
        z-index: 1;
    }

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        pointer-events: none;
        z-index: 0;

        background: ${({ theme, $status }) =>
            $status
                ? `color-mix(in srgb, ${theme.successTypographyColor} 20%, transparent)`
                : `color-mix(in srgb, ${theme.dangerTypographyColor} 20%, transparent)`};
    }
`;

export const StatusIconContainer = styled.div<{ $status: boolean }>`
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 16px;

    color: ${({ theme, $status }) =>
        $status ? theme.successTypographyColor : theme.dangerTypographyColor};
`;
